import { FC } from 'react'
import { About } from './About'
import { Portfolio } from './Portfolio'
import * as layout from '../styles/Layout.styled'
import { Section } from '../typing/enums'
import { NavProps } from '../typing/interfaces'

export const Main: FC<NavProps> = ({
  aboutSection,
  portfolioSection,
}) => {
  return (
    <layout.StyledMain>
      <layout.StyledSection ref={aboutSection} id={Section.about}>
        <About />
      </layout.StyledSection>
      <layout.StyledSection ref={portfolioSection} id={Section.portfolio}>
        <Portfolio />
      </layout.StyledSection>
    </layout.StyledMain>
  )
}
